import React, { FC } from "react";
import { MenuItem } from "@familyzone/component-library";
import { MenuItemProps } from "@chakra-ui/react";

export const HeaderMenuItem: FC<MenuItemProps> = ({ children, ...props }) => (
  <MenuItem p="sp8" color="text.paragraph.title" fontFamily="paragraphs" borderRadius="4px" {...props}>
    {children}
  </MenuItem>
);
